import {EAuthProfile} from 'store/slices/auth-slice/auth-slice-types';

export const AUTH_SLICE = 'AUTH_SLICE';

export const AuthResponseTypes = {
    PASSWORD_EXPIRED: 'PASSWORD EXPIRED',
    UNAUTHORIZED: 'UNAUTHORIZED',
    INVALID_VERIFICATION_CODE: 'Invalid verification code',
    NEED_2FA: 'NEED_2FA',
};

export const AuthErrors = {
    DEFAULT_ERROR_MESSAGE: 'Произошла непредвиденная ошибка. Обратитесь к администратору',
    USER_INFO_ERROR_MESSAGE: 'Не удалось получить информацию о пользователе',
    CHANGE_PASSWORD_SETTINGS_REQUEST_FAILED: 'Не удалось получить информацию о составе регулярного выражения '
        + 'для пароля. Обратитесь к администратору',
    PROFILE_NOT_FOUND: 'Не удалось получить информацию о профиле входа. Обратитесь к администратору',
    FORBIDDEN: 'Недостаточно прав для просмотра страницы',
    MICROSERVICE_TOKEN_ERROR: 'Произошла ошибка при авторизации в микросервис',
    PASSWORD_EXPIRED: 'Требуется смена пароля',
};

export const SESSION_EXPIRED_NOTIFICATION = {
    KEY: 'sessionClosedKey',
    MESSAGE: 'Сеанс завершён',
    DESCRIPTION: 'Сеанс был завершён в связи с отсутствием пользовательской активности',
} as const;

export const EXTERNAL_AUTH_PROFILES: EAuthProfile[] = [
    EAuthProfile.SAML,
    EAuthProfile.KEYCLOAK,
];
